import {Command} from './Command';
import {AddObjectAction} from '../actions';
import {StageService} from '../../stage.service';

export class AddObjectCommand extends Command<AddObjectAction> {

  private object;

  constructor(
    private stage: StageService
  ) {
    super();
  }

  do(action: AddObjectAction) {
    this.object = action.object;
    this.stage.add(this.object);
  }

  undo() {
    this.stage.remove(this.object);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/AddObjectCommand.ts